import Accordion from "@/common/components/Accordion";
import { EmptyDataMessage } from "@/common/components/EmptyDataMessage";
import { EstablishmentCompanyData } from "@/common/types/establishment/company.type";
import CreateMaintenanceRequiredDocument from "./CreateMaintenanceRequiredDocument";
import MaintenanceRequiredDocumentItem from "./MaintenanceRequiredDocumentItem";

interface MaintenanceRequiredDocumentsSectionProps {
  establishmentCompany?: EstablishmentCompanyData;
  disabled?: boolean;
}

const MaintenanceRequiredDocumentsSection = ({
  establishmentCompany,
  disabled,
}: MaintenanceRequiredDocumentsSectionProps) => {
  return (
    <Accordion
      className="p-0"
      triggerClassName="p-4"
      bodyClassName="p-4 pt-0"
      defaultOpen
      head={(
        <div className="flex items-center gap-3">
          <div onClick={(event) => {
            event.stopPropagation();
          }}>
            <CreateMaintenanceRequiredDocument
              establishmentCompany={establishmentCompany}
              disabled={disabled}
            />
          </div>

          <p className="text-lg font-bold">
            Documentos do estabelecimento
          </p>
        </div>
      )}
      body={(
        <div className="flex flex-col gap-4">
          {!establishmentCompany?.maintenance_required_documents?.length && (
            <EmptyDataMessage className="h-54 overflow-hidden" imageHeight={120} />
          )}

          {establishmentCompany?.maintenance_required_documents?.map((maintenanceRequiredDocument) => (
            <MaintenanceRequiredDocumentItem
              key={maintenanceRequiredDocument.document.id}
              establishmentCompany={establishmentCompany}
              maintenanceRequiredDocument={maintenanceRequiredDocument}
              disabled={disabled}
            />
          ))}
        </div>
      )}
    />
  );
}

export default MaintenanceRequiredDocumentsSection;
